import React from "react";
import "./about.css";
import me from "../../asset/me.png";

// TODO: replace these with your real numbers before deploying
const aboutCards = [
  { icon: "fa-solid fa-award", title: "Experience", text: "6+ Years Experience" },
  { icon: "fa-solid fa-users", title: "Clients", text: "XX+ Clients Served" },
  { icon: "fa-solid fa-folder", title: "Projects", text: "XX+ Completed" },
];

function About() {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about_container">
        <div className="about_me">
          <div className="about_me-image">
            <img src={me} alt="Olatunji Akande" />
          </div>
        </div>
        <div className="about_content">
          <div className="about_cards">
            {aboutCards.map((card) => (
              <article className="about_card" key={card.title}>
                <i className={card.icon}></i>
                <h5>{card.title}</h5>
                <small>{card.text}</small>
              </article>
            ))}
          </div>
          <p>
            I'm Olatunji Akande, a full-stack developer who builds and ships
            complete products: multi-vendor marketplaces, multi-tenant SaaS
            platforms, payment flows, admin dashboards, and Android apps
            published on Google Play.
          </p>
          <p>
            My core stack is JavaScript/TypeScript with React, Next.js, and
            Node.js, backed by MongoDB, PostgreSQL, and MySQL, with Redux,
            Tailwind, and MUI on the frontend and Redis for caching and
            performance. I'm also expanding into PHP and Laravel, which lets me
            work on existing Laravel codebases and customize admin panels as
            well as build new projects.
          </p>
          <p>
            I care about code that is fast, secure, and easy to maintain. Let's
            build something great together.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
}

export default About;